import request from "@/utils/request";

// 登录
export const useAutoLogin = (data) => request({url: "wechat/auto-login", method: 'post', data});
// 登录
export const accountLogin = (data) => request({url: "upm/account/login", method: 'post', data});
// 获取企业的树形结构部门
export const getTreeGroup = (params) => request({ url: 'wechat/get-tree-group', method: 'get', params});
